import { render } from "./MeusBloqueiosView.vue?vue&type=template&id=6dd30bad"
import script from "./MeusBloqueiosView.vue?vue&type=script&lang=js"
export * from "./MeusBloqueiosView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__